import {notNull} from '../../../../../../library/clxProductNet/assets/js/modules/common/assert';
import AnalyticsTracker from '../../../../../../library/clxProductNet/assets/js/modules/common/tracking/analyticsTracker';
import {EventCategoryEnum} from '../../common/trackingFrontend/Model/EventCategoryEnum';
import {EventNotificationBarEnum} from '../../common/trackingFrontend/Model/EventNotificationBarEnum';
import {FeCmsNoticationTimer} from './feCmsNoticationTimer';
import {FeCmsNotificationCookie} from './feCmsNotificationCookie';

export class FeCmsNotificationBar {
    private readonly className: string;

    private readonly notifcationBar: HTMLElement;

    private readonly notificationTimer: FeCmsNoticationTimer;

    private readonly notificationCookie: FeCmsNotificationCookie;

    constructor(className: string) {
        this.className = className;
        this.notifcationBar = notNull(document.querySelector(`.${className}`)) as HTMLDivElement;
        this.notificationTimer = new FeCmsNoticationTimer(className);
        this.notificationCookie = new FeCmsNotificationCookie(className);

        this._init();
    }

    private _init() {
        // init close event listener for hint
        this._initCloseEventListener();
        this._initCtaTracking();
    }

    private _initCloseEventListener(): void {
        const closeElement = notNull(this.notifcationBar.querySelector('.close-overlay')) as HTMLDivElement;
        closeElement.addEventListener('click', () => {
            const tracking = new AnalyticsTracker();
            tracking.fireHotjarTrackingEvent(EventCategoryEnum.notificationBar, EventNotificationBarEnum.closed);

            this.notifcationBar.remove();
            this.notificationCookie.setDisableHintCookie();
        });
    }

    private _initCtaTracking(): void {
        const ctaLinkElement: HTMLLinkElement | null = this.notifcationBar.querySelector('.message > a');
        ctaLinkElement?.addEventListener('click', () => {
            const tracking = new AnalyticsTracker();
            tracking.fireMatomoTrackingEvent(EventCategoryEnum.notificationBar, EventNotificationBarEnum.ctaButtonClicked);
        });
    }
}
